/* Gedeelde formatting helper voor de Signals-subcomponenten. */
import { fmtDateTime as fmtDT } from "@/lib/datetime";

/* "08 jul 2026 · 15:04" in the WORKSPACE timezone (UTC-safe parsing). */
export const fmtDateTime = (iso) => {
    if (!iso) return "—";
    const s = fmtDT(iso, { year: true });
    return s ? s.replace(", ", " · ") : "—";
};
